var styles = {"box":"VipIcon_box_631ly_1","reverse":"VipIcon_reverse_631ly_7","icon-bg":"VipIcon_icon-bg_631ly_10","icon":"VipIcon_icon_631ly_10","text":"VipIcon_text_631ly_31","v2":"VipIcon_v2_631ly_54","sm":"VipIcon_sm_631ly_72","lg":"VipIcon_lg_631ly_92","no-available":"VipIcon_no-available_631ly_102"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
